module.exports = {"350103001":"瀛洲街道","350103002":"后洲街道","350103003":"义洲街道","350103004":"新港街道","350103005":"上海街道","350103007":"苍霞街道","350103009":"茶亭街道","350103010":"洋中街道","350103011":"鳌峰街道","350103012":"宁化街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350103.json
// module id = 1270
// module chunks = 0